module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', [_vm._l((_vm.items), function(i) {
    return _h('div', {
      staticClass: "media"
    }, [_h('div', {
      staticClass: "media-left"
    }, [_h('img', {
      staticClass: "media-object",
      attrs: {
        "src": 'https://qiniu443.alltennis.cn/' + i.thumb + '?imageView2/2/h/160/interlace/1'
      }
    })]), _h('div', {
      staticClass: "media-body"
    }, [_h('h5', [_h('router-link', {
      attrs: {
        "to": {
          name: 'news',
          params: {
            id: i.id
          }
        }
      }
    }, [_vm._s(i.title)])]), _h('p', [_vm._s(i.intro)]), _h('p', {
      staticClass: "small"
    }, [_vm._m(0), " \n" + _vm._s(i.author) + " / " + _vm._s(_vm._f("time")(i.timeCreate))]), _h('p', {
      staticClass: "small"
    }, [_vm._m(1), " \n" + _vm._s(i.count.views)])]), _vm._m(2, true)])
  }), (_vm.items.length) ? _h('ul', {
    staticClass: "pagination"
  }, [_vm._l((_vm.pageLinks), function(i) {
    return _h('li', {
      class: {
        active: i == _vm.page
      }
    }, [_h('router-link', {
      attrs: {
        "to": {
          name: 'index',
          query: {
            p: i
          }
        },
        "exact": "exact"
      }
    }, [_vm._s(i)])])
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('span', {
    staticClass: "glyphicon glyphicon-user"
  })
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('span', {
    staticClass: "glyphicon glyphicon-eye-open"
  })
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('hr')
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-52bbf466", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52bbf466!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 20
// module chunks = 0